import React, { useEffect, useMemo, useState } from "react";
import { Layout, Table, Modal, Row, Col, DatePicker, Input } from "antd";

// utils
import {
  getMonitorLambdaList,
  getMonitorLambdaLog,
} from "./utils/getMonitorData";

// type
import { MonitorLambda, defaultMonitorLambda } from "../../types/monitorLambda";

// component
import Sidebar from "../../component/Sidebar";
import moment from "moment";
import { debounce } from "lodash";
import MonitorLambdaLogComponent from "./MonitorLambdaLog";

const MonitorLambdaComponent = () => {
  const { Header, Content, Sider } = Layout;
  const { RangePicker } = DatePicker;

  const [list, setList] = useState<MonitorLambda[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filter, setFilter] =
    useState<any>(/* {
    date_start: moment().format("YYYY-MM-DD 00:00:00"),
    date_end: moment().format("YYYY-MM-DD 23:59:59"),
  } */);
  const [selectedLambda, setSelectedLambda] =
    useState<MonitorLambda>(defaultMonitorLambda);
  const [modalVisible, setModalVisible] = useState(false);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 50,
    total: 50,
  });

  const handleTableChange = async (
    pagination: any,
    filters: any,
    sorter: any
  ) => {
    try {
      setIsLoading(true);
      const listMonitorLambda = await getMonitorLambdaList({
        ...filter,
        sortField: sorter.field,
        sortOrder: sorter.order,
        ...pagination,
        ...filters,
      });
      setList(listMonitorLambda.collections);
      setPagination({
        ...pagination,
        total: listMonitorLambda.total_data,
      });
      setIsLoading(false);
    } catch (err) {}
  };

  const columns = [
    {
      title: "URL",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Lambda",
      dataIndex: "function_name",
      key: "function_name",
    },
    {
      title: "Updated at",
      dataIndex: "updated_at",
      key: "updated_at",
    },
  ];

  const getMonitorLambda = async () => {
    try {
      setIsLoading(true);
      const listMonitorLambda = await getMonitorLambdaList({
        ...pagination,
        ...filter,
      });
      setList(listMonitorLambda.collections);
      setPagination({
        ...pagination,
        total: listMonitorLambda.total_data,
      });
      setIsLoading(false);
    } catch (err) {}
  };

  const renderStatus = (status: string) => {
    switch (status) {
      case "lived":
        return "Live";
      case "downed":
        return "Down";

      default:
        return status;
    }
  };

  const renderDate = (
    date: string | null | undefined,
    includeHour?: boolean
  ) => {
    const format = includeHour ? "DD MMM YYYY, HH:mm" : "DD MMM YYYY";
    return date ? moment(date).format(format) : "-";
  };

  const getFormattedList = useMemo(() => {
    let result: MonitorLambda[] = list.map((p: MonitorLambda) => {
      return {
        id: p.id,
        function_name: p.function_name,
        status: renderStatus(p.status),
        updated_at:
          p.updated_at !== "None" ? renderDate(p.updated_at, true) : "Not yet",
      };
    });

    return result;
  }, [list, filter]);

  useEffect(() => {
    getMonitorLambda();
  }, [filter]);

  const onDateChange = debounce((values: any, dateString: [string, string]) => {
    setFilter({
      ...filter,
      date_start:
        values === null ? "" : values[0].format("YYYY-MM-DD 00:00:00"),
      date_end: values === null ? "" : values[1].format("YYYY-MM-DD 23:59:59"),
    });
  }, 800);

  const onDateOK = debounce((values: any) => {
    setFilter({
      ...filter,
      date_start:
        values === null ? "" : values[0].format("YYYY-MM-DD 00:00:00"),
      date_end: values === null ? "" : values[1].format("YYYY-MM-DD 23:59:59"),
    });
  }, 800);

  const onSearch = debounce((e: React.ChangeEvent<HTMLInputElement>) => {
    setFilter({ ...filter, [e.target.name]: e.target.value });
  }, 800);

  const handleSelectLambda = async (record: any) => {
    setModalVisible(true);
    setSelectedLambda(record);
  };

  const handleCloseModal = () => {
    setModalVisible(false);
  };

  return (
    <>
      <Modal
        visible={modalVisible}
        onCancel={handleCloseModal}
        onOk={handleCloseModal}
        confirmLoading={isLoading}
        width={1000}
      >
        <MonitorLambdaLogComponent lambda_id={selectedLambda.id} />
      </Modal>

      <Layout style={{ height: "100vh" }}>
        <Sider breakpoint="lg" collapsedWidth="0">
          {/* <Sidebar activeTab={"monitor-lambda"} /> */}
        </Sider>
        <Layout>
          <Header style={{ background: "#fff" }}>
            <h1>Monitor Lambda</h1>
          </Header>
          <Content
            style={{
              padding: "24px",
              paddingBottom: "100px",
              overflowY: "scroll",
            }}
          >
            <Row style={{ marginBottom: "16px" }}>
              <Col span={8}>
                <Input
                  name="function_name"
                  placeholder="Cari lambda"
                  onChange={onSearch}
                />
              </Col>
            </Row>
            <Table
              rowKey={(record) => record.id}
              dataSource={getFormattedList}
              columns={columns}
              pagination={pagination}
              loading={isLoading}
              onChange={handleTableChange}
              onRow={(record, rowIndex) => {
                return {
                  onClick: (event) => {
                    handleSelectLambda(record);
                  }, // click row
                };
              }}
            />
          </Content>
        </Layout>
      </Layout>
    </>
  );
};

export default MonitorLambdaComponent;
